// @ts-nocheck

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { notification } from "antd";
import { http } from "../../../engine/api/http";
import {
  levels,
  roles,
  statusPrestationsValues,
  subStatus,
  subStatusPrestations,
} from "../../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import routes from "../../../engine/routes";
import { useNavigate } from "react-router-dom";
import dayjs from "../../../utils/dayjs";
import _ from "lodash";
import { ansi } from "chalk";
import { router } from "../../../engine/router/AppRouter";
import {
  confirmAnswerYesPrestation,
  modalModificationPrestationFinishPending,
  modalModificationPrestationPending,
} from "../../../shared/components/Modals/modals";
import { initialStatePrestation } from "./Prestation.default.state";
import i18n from "i18next";

export const getPrestation = createAsyncThunk(
  "prestation/getPrestation",
  async (prestationId, thunkAPI) => {
    const res = await http.get("/prestations/" + prestationId);

    // thunkAPI.dispatch(getInterpretesSearch());

    // Accessing headers from the response
    const headers = res.headers;

    // Example: Accessing a specific header, e.g., 'X-Custom-Header'
    const customHeader = headers["X-by-ref"];

    return res.data;
  },
);

export const getEstimationCost = createAsyncThunk(
  "prestation/getEstimationCost",
  async (prestationId, thunkAPI) => {
    const res = await http.get(`/prestations/${prestationId}/cost`);

    return res.data;
  },
);

export const getInterpretesSearch = createAsyncThunk(
  "prestation/getInterpretesSearch",
  async (prestationId, thunkAPI) => {
    const prestation = thunkAPI.getState().prestation.prestation;

    const res = await http.get(`/prestations/${prestationId}/search`);

    // const res = await http.get(`users?role=${roles.interprete}`);

    return res.data;
  },
);

export const postAppelInterpretes = createAsyncThunk(
  "prestation/postAppelInterpretes",
  async (prestationId, thunkAPI) => {
    const { _id } = thunkAPI.getState().prestation.prestation;

    // const res = await http.get(`/prestations/${prestationId}/search`);

    const res = await http.post(`prestations/${_id}/appel_interpretes`);

    return res.data;
  },
);

export const postAnswerChangeApprovedRefused = createAsyncThunk(
  "prestation/postAnswerChange",
  async (answer, thunkAPI) => {
    const { _id } = thunkAPI.getState().prestation.prestation;

    const res = await http.post(`prestations/${_id}/interprete_answer_change`, {
      answer,
    });

    return res.data;
  },
);

export const postManuelPrestation = createAsyncThunk(
  "prestation/postManuelPrestation",
  async (prestationId, thunkAPI) => {
    const { _id } = thunkAPI.getState().prestation.prestation;

    const res = await http.post(`prestations/${_id}/confirm_planned`);

    return res.data;
  },
);

export const postInterpretesAnswer = createAsyncThunk(
  "prestation/postInterpretesAnswer",
  async ({ answer, interpreteId, invitationToken }, thunkAPI) => {
    const { _id } = thunkAPI.getState().prestation.prestation;

    // const res = await http.get(`/prestations/${prestationId}/search`);

    const res = await http.post(`prestations/${_id}/answer`, {
      answer,
      interpreteId,
      invitationToken,
    });

    return res.data;
  },
);

export const deletePrestation = createAsyncThunk(
  "prestation/deletePrestation",
  async (payload, thunkAPI) => {
    const { _id } = thunkAPI.getState().prestation.prestation;

    const res = await http.delete(`prestations/${_id}`);

    return res.data;
  },
);
export const duplicatePrestation = createAsyncThunk(
  "prestation/duplicatePrestation",
  async (payload, thunkAPI) => {
    const { _id } = thunkAPI.getState().prestation.prestation;

    const res = await http.post(`prestations/${_id}/duplicate`);

    return res.data;
  },
);

export const updatePrestation = createAsyncThunk(
  "prestation/update",
  async (payload, thunkAPI, state) => {
    const prestation = thunkAPI.getState().prestation.prestation;

    if (prestation._id !== undefined) {
      if (
        prestation.status === statusPrestationsValues.planned ||
        prestation.status === statusPrestationsValues.waiting
      ) {
        const showModalConfirmUpdate = await new Promise((resolve, reject) => {
          modalModificationPrestationPending({
            onOk: async () => {
              resolve(true);
            },
            onCancel: () => {
              reject(new Error("Update canceled."));
            },
          });
        });

        if (showModalConfirmUpdate) {
          const resapproval = await http.patch(
            `/prestations/${prestation._id}/approval`,
            prestation,
          );
          notification.success({
            message: `Richiesta di modifica accetta`,
          });

          const res = await http.get("/prestations/" + prestation._id);

          return res.data;
        }
      } else if (
        [
          statusPrestationsValues.finish,
          statusPrestationsValues.finish_notsigned,
          statusPrestationsValues.finish_permanance,
          statusPrestationsValues.cancel,
          statusPrestationsValues.cancelClient,
          statusPrestationsValues.cancelInterprete,
        ].includes(prestation.status) ||
        [subStatus.interprete, subStatus.institution].includes(
          prestation.subStatus,
        )
      ) {
        const showModalConfirmFinishUpdate = await new Promise(
          (resolve, reject) => {
            modalModificationPrestationFinishPending({
              onOk: async () => {
                resolve(true);
              },
              onCancel: () => {
                reject(new Error("Update canceled."));
              },
            });
          },
        );

        if (showModalConfirmFinishUpdate) {
          const resPatch = await http.patch(
            "/prestations/" + prestation._id,
            prestation,
          );

          // let syncBill;

          // syncBill = await http.post(`/bills/upsertOneBillOnePrestation`, {
          //   prestation: prestation._id,
          // });

          const res = await http.get("/prestations/" + prestation._id);

          notification.success({
            message: `Prestazione modificata`,
          });

          return res.data;
        }
      } else {
        const res = await http.patch(
          "/prestations/" + prestation._id,
          prestation,
        );
        notification.success({
          message: `Prestazione modificata`,
        });
        return res.data;
      }
    } else {
      const res = await http.post("/prestations/new", prestation);
      // thunkAPI.dispatch(updatePrestationOnList(res.data));
      notification.success({
        message: `Prestation Créée`,
      });
      return res.data;
    }
  },
);

export const updateAdminPrestation = createAsyncThunk(
  "prestation/updateAdminPrestation",
  async (payload, thunkAPI, state) => {
    const prestation = thunkAPI.getState().prestation.prestation;

    const resPatch = await http.patch(
      "/prestations/" + prestation._id,
      prestation,
    );

    notification.success({
      message: `Prestazione modificata`,
    });
  },
);

export const updateControlPrestation = createAsyncThunk(
  "prestation/updateControlPrestation",
  async (payload, thunkAPI, state) => {
    const prestation = thunkAPI.getState().prestation.prestation;

    const res = await http.patch(
      "/prestations/" + prestation._id + "/control",
      prestation,
    );

    notification.success({
      message: `Prestazione modificata`,
    });

    return res.data;
  },
);

export const followPrestation = createAsyncThunk(
  "prestation/follow",
  async (payload, thunkAPI, state) => {
    const res = await http.post(
      `/prestations/${payload.followedPrestation}/follow`,
      payload,
    );
    notification.success({
      message: `Prestation de suivie créée`,
    });
    return res.data;
  },
);

export const cancelPrestation = createAsyncThunk(
  "prestation/cancel",
  async (payload, thunkAPI, state) => {
    const prestation = thunkAPI.getState().prestation.prestation;

    const resCancel = await http.post(
      `/prestations/${prestation._id}/cancel`,
      prestation,
    );
    notification.success({
      message: `Prestation annulée`,
    });

    const res = await http.get("/prestations/" + prestation._id);

    return res.data;
  },
);

export const finishPrestation = createAsyncThunk(
  "prestation/finishPrestation",
  async (payload, thunkAPI, state) => {
    const prestation = thunkAPI.getState().prestation.prestation;

    const res = await http.post(
      `/prestations/${prestation._id}/finish`,
      prestation,
    );
    notification.success({
      message: `Prestation terminée`,
    });
    return res.data;
  },
);

const prestationSlice = createSlice({
  name: "prestation",
  initialState: initialStatePrestation,
  reducers: {
    clearPrestation: state => {
      return initialStatePrestation;
    },
    dangerousUpdate: state => {
      state.dangerousUpdate = true;
    },
    changeStatusInterprete: (state, action) => {
      let ref = state.prestation.interpretesStatus.find(
        e => e.interprete._id === action.payload._id,
      );

      if (ref.status === "selected") {
        state.prestation.interprete = null;
      }

      if (action.payload.status === "selected") {
        ref.selectedAt = dayjs().format();
      }

      ref.status = action.payload.status;
    },
    changePositionInterprete: (state, action) => {
      let ref = state.prestation.interpretesStatus.find(
        e => e.interprete._id === action.payload._id,
      );
      ref.position = action.payload.position;
    },
    setPrestation: (state, action) => {
      state.prestation = action.payload;
    },
    setPropertiesPrestation: (state, action) => {
      /*
      * In this example, the customizer function is checking if the property is an array. If it is, the value from action.payload (srcValue) will replace the value in state.prestation (objValue), effectively making action.payload the "master" object. If the property is not an array, Lodash will default to its normal merge behavior.
      This way, you'll still get a deep merge for nested objects, but you can customize how arrays (or other types if you need) are handled.
      * */
      const customizer = (objValue, srcValue) => {
        if (_.isArray(objValue)) {
          return srcValue;
        }
      };

      let merged = _.mergeWith(
        {},
        state.prestation,
        action.payload,
        customizer,
      );

      state.prestation = merged;
    },
    setSelectedInterprete: (state, action) => {
      // All set to not invited
      state.prestation.interpretesStatus = state.prestation.interpretesStatus.map(
        e => {
          if (e.status === "selected" || e.status === "invited") {
            e.status = "not_invited";
          }

          e.selectedAt = null;

          return e;
        },
      );

      state.prestation.interprete = action.payload;
    },
  },
  extraReducers: {
    [getPrestation.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getEstimationCost.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getEstimationCost.fulfilled]: (state, { payload }) => {
      state.cost = payload;
      state.loading = false;
    },
    [deletePrestation.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [deletePrestation.fulfilled]: (state, { payload }) => {
      notification.success({
        message: `Supprimé avec succès`,
      });
      router.navigate("/", { replace: true });

      return initialStatePrestation;
    },
    [getInterpretesSearch.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getInterpretesSearch.fulfilled]: (state, { payload }) => {
      state.prestation.interpretesStatus = payload.interpretesStatus;
      state.prestation.searchInterpretes = payload.searchInterpretes;
      state.loading = false;
      state.interpretesHasSearch = true;
    },
    [getPrestation.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.ready = true;
      state.prestation = payload;
    },
    [updatePrestation.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [updatePrestation.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [updatePrestation.fulfilled]: (state, { payload }) => {
      state.prestation = payload;
      state.cost = null;
      state.loading = false;
    },
    [updateAdminPrestation.pending]: (state, { payload }) => {
      state.loadingEdit = true;
    },
    [updateControlPrestation.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [updateControlPrestation.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.prestation = payload;
    },
    [updateAdminPrestation.rejected]: (state, { payload }) => {
      state.loadingEdit = false;
    },
    [updateAdminPrestation.fulfilled]: (state, { payload }) => {
      state.loadingEdit = false;
    },
    [cancelPrestation.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [cancelPrestation.fulfilled]: (state, { payload }) => {
      state.prestation = payload;
      state.loading = false;
    },
    [followPrestation.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [followPrestation.fulfilled]: (state, { payload }) => {
      router.navigate(routes.prestations(payload._id).detail.path, {
        replace: true,
      });

      state.loading = false;
    },
    [duplicatePrestation.pending]: (state, { payload }) => {
      state.loading = true;
      state.ready = false;
    },
    [duplicatePrestation.rejected]: (state, action) => {
      state.loading = true;
    },
    [duplicatePrestation.fulfilled]: (state, { payload }) => {
      // state = payload;
      // state.prestation = payload;

      // state = initialStatePrestation;

      // return initialStatePrestation;
      router.navigate(routes.prestations(payload._id).detail.path, {
        replace: true,
        state: { force: true },
      });

      // return initialStatePrestation;

      state.loading = false;
    },
    [finishPrestation.pending]: (state, { payload }) => {},
    [finishPrestation.fulfilled]: (state, { payload }) => {
      state.prestation = payload;
    },
    [postInterpretesAnswer.pending]: (state, { payload }) => {
      state.loadingAnswer = true;
    },
    [postInterpretesAnswer.rejected]: (state, response) => {
      state.loadingAnswer = false;
    },
    [postInterpretesAnswer.fulfilled]: (state, { payload }) => {
      if (payload.finalAnswer) {
        confirmAnswerYesPrestation({
          onCancel: () => {
            router.navigate("/", { replace: true });
          },
        });
      } else {
        notification.success({
          message: `Merci pour votre réponse`,
        });
        router.navigate("/", { replace: true });
      }

      state.prestation = payload.prestation;
      state.loadingAnswer = false;
    },
    [getPrestation.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [postAppelInterpretes.pending]: (state, { payload }) => {
      state.loadingAppel = true;
    },
    [postAppelInterpretes.fulfilled]: (state, { payload }) => {
      notification.success({
        message: i18n.t("notification.success.message"),
        description: i18n.t("notification.success.description", {
          count: payload.sent,
        }),
      });

      state.prestation = payload.prestation;
      state.loadingAppel = false;
    },
    [postAnswerChangeApprovedRefused.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [postAnswerChangeApprovedRefused.fulfilled]: (state, { payload }) => {
      notification.success({
        message: `Risposta registrata`,
      });
      state.prestation = payload.prestation;
      state.loading = false;
    },
    [postManuelPrestation.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [postManuelPrestation.fulfilled]: (state, { payload }) => {
      notification.success({
        message: `Prestation confirmée et prévue`,
      });
      state.prestation = payload.prestation;
      state.loading = false;
    },
  },
});

export const initPrestationSlice = ({ id }) => {
  const dispatch = useDispatch();

  const [ready, setReady] = useState(id === "new");

  const { prestation, loading } = useSelector(state => state.prestation);
  const navigate = useNavigate();

  const { _id } = prestation;

  const init = async () => {
    if (prestation._id !== id && id !== "new") {
      if (prestation._id !== undefined) {
        await clear();
      }
      await dispatch(getPrestation(id));
    }
  };

  const clear = async () => {
    await dispatch(clearPrestation());
  };

  useEffect(() => {
    if (prestation._id !== undefined && id === "new") {
      navigate(routes.prestations(prestation._id).detailInterpretes.path, {
        replace: true,
      });
    }

    init();

    if (
      prestation._id !== undefined &&
      id === prestation._id &&
      loading !== true
    ) {
      setReady(true);
    }
  }, [prestation]);

  const resetToNew = async () => {
    if (id === "new" && prestation._id !== undefined && prestation._id !== id) {
      // Reset when go to a new one
      await clear();
      navigate(routes.prestations().new.path, {
        replace: true,
      });
    }
  };

  useEffect(() => {
    init();

    resetToNew();

    return () => {
      // clear();
    };
  }, []);

  return { init, clear, ready };
};

export const {
  changeStatusInterprete,
  setSelectedInterprete,
  clearPrestation,
  changePositionInterprete,
  dangerousUpdate,
  setPropertiesPrestation,
  setPrestation,
} = prestationSlice.actions;

export const prestationReducer = prestationSlice.reducer;
